import * as THREE from 'three';
import { BaseCabinet } from '../base/BaseCabinet';
import { TypeCabinet } from '../../../constants/enum';
import { DeskModule } from '../modules/DeskModule';

export class DeskCabinet extends BaseCabinet {
  constructor(sceneManager) {
    super(TypeCabinet.DESK, sceneManager);
    this.constraints = this.getConstraints();
  }

  getConstraints() {
    return {
      groundOffset: 0,
      wallOffset: 10,

      typePriorities: {
        low: 1,
        tall: 2,
        bench: 3,
      },

      typeHeights: {
        low: 900,   // Tủ giày thấp (mm)
        tall: 1800, // Tủ giày cao (mm)
        bench: 450, // Ghế ngồi (mm)
      },
    };
  }

  getActiveMeshPoints(cloneModule) {
    return cloneModule?.getMeshPoints?.() || [];
  }

  createModule(moduleData, moduleType, constraints) {
    return new DeskModule(
      moduleData,
      moduleType,
      this.sceneManager,
      this,
      constraints
    );
  }

  setActiveEditorModuleByUuid(uuid) {
    const module = this.getModuleByGroupUuid(uuid);
    if (module) {
      this.activeEditorModule = module;
      return true;
    }
    return false;
  }
}